export default (_atts) => ({
    input_address: _atts.input_address,
    input_city: _atts.input_city,
    input_zipcode: _atts.input_zipcode,
    input_latitude: _atts.input_latitude,
    input_longitude: _atts.input_longitude,
    showResults: false,
    items: [],
    selection_key: null,
    old_address_input: '',
    old_city_input: '',
    old_zipcode_input: '',
    path: "https://api-adresse.data.gouv.fr/search/?q=",


    /*
        Méthode qui s'active a chaque touche de clavier
        A se méfier car les touches haut, bas et entrer active aussi cette methode
     */

    onAdressKeyup() {
        if(this.input_address && this.input_address != this.old_address_input)
        {
            axios.get( this.path.concat(this.input_address) ).then(
                (response) => {
                    var features = response.data.features

                    this.resetData()

                    for (let i = 0; i < features.length; i++) {
                        if(features[i].properties.street)
                        {
                            this.items.push({
                                'title': features[i].properties.label,
                                'data': features[i],
                                'show': false,
                            })
                        }
                    }
                    this.showResults = true
                },
                (error) => {
                    console.error(error);
                }
            );
        }
    },

    // Reset data va nous permettre d'afficher une nouvelle recherche d'adresse
    // ResetData est activé quand l'utilisateur modifie l'adresse
    // Cela nous permet de vérifier si l'utilisateur à bien choisi une adresse depuis l'API
    resetData() {
        this.items = []
        this.selection_key = null
        this.old_address_input = this.input_address
        this.input_longitude = null
        this.input_latitude = null
        //this.input_zipcode = null
        //this.input_city = null
    },

    onAdressDown() {
        if(this.showResults && this.items.length > 0)
        {
            if(this.selection_key == null)
            {
                this.selection_key = 0;
            }
            else if(this.selection_key+1 < this.items.length)
            {
                this.selection_key = this.selection_key + 1
            }
        }
    },

    onAdressUp() {
        if(this.showResults && this.items.length > 0)
        {
            if(this.selection_key == 0)
            {
                this.selection_key = null
            }
            else if(this.selection_key-1 >= 0)
            {
                this.selection_key = this.selection_key - 1
            }
        }
    },

    onAdressEnter() {
        var item = this.items[this.selection_key].data
        this.completeAddress(item)
    },

    onAdressFocus() {
        if(this.items.length)
        {
            this.showResults = true
        }
    },

    onAdressBlur() {
        this.showResults = false
    },

    autocompleteItemClick(item) {
        var item = item.data

        this.completeAddress(item)
    },

    completeAddress(item) {
        var properties = item.properties

        if(properties.housenumber)
        {
            this.input_address = properties.housenumber+" "+properties.street
        }
        else
        {
            this.input_address = properties.street
        }

        this.input_city = properties.city
        this.input_zipcode = properties.postcode

        this.input_longitude = item.geometry.coordinates[0]
        this.input_latitude = item.geometry.coordinates[1]

        this.old_address_input = this.input_address
        this.old_city_input = this.input_city
        this.old_zipcode_input = this.input_zipcode
        this.items = []
        this.showResults = false
    },

    onCityAdressFieldChange() {
        if(this.input_city != this.old_city_input) {
            this.input_longitude = null
            this.input_latitude = null
        }
    },

    onZipcodeAdressFieldChange() {
        if(this.input_zipcode != this.old_zipcode_input) {
            this.input_longitude = null
            this.input_latitude = null
        }
    }

})